import { render, staticRenderFns } from "./InquiryBureau.vue?vue&type=template&id=69c887a5&scoped=true&"
import script from "./InquiryBureau.vue?vue&type=script&lang=js&"
export * from "./InquiryBureau.vue?vue&type=script&lang=js&"
import style0 from "./InquiryBureau.vue?vue&type=style&index=0&id=69c887a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c887a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VIcon,VSelect})
